




































import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { DropdownItem } from '@/app/shared/models';
import UiIconComponent from '@/app/shared/components/ui/ui-icon-component.vue';
import { uniqueId } from 'lodash';

@Component({
  components: {
    UiIconComponent
  }
})
export default class UiDropDownComponent extends Vue {
  @Prop()
  public label: string;

  @Prop()
  public items: DropdownItem[];

  @Prop({ required: true })
  public selectedId!: string;

  public selectedIdInternal: string = this.selectedId;

  public open: boolean = false;

  public dropdownId: string = uniqueId();

  public onItemSelected(id: string): void {
    if (this.selectedIdInternal !== id) {
      this.selectedIdInternal = id;
      this.emitSelected(id);
      this.open = false;
    } else {
      this.toggle();
    }
  }

  @Emit('selected')
  public emitSelected(id: string): string {
    return id;
  }

  public toggle(): void {
    this.open = !this.open;
  }
}
